import React from 'react'
import { Trans } from '@lingui/react/macro'

import type { ReactNode } from 'react'
import type { EPaidProductType } from '@/contexts/PlanContext/type'
import type {
  TListItem,
  TUseProductText,
} from '@/contexts/PlanContext/hooks/productText'

import { EProductType } from '@/contexts/PlanContext/type'
import ListItem from '@/_blocks/Plan/ListItem'
import LazyImage from '@/components/LazyImage'


import { cls, tw } from 'tagged-classnames-free';
import { useMemo } from 'react';
export interface IPlanCardTemplateProps {
  className?: string
  productTextInfo: TUseProductText
  productType: EPaidProductType | EProductType
  productName: ReactNode
  BuyButton: React.ReactNode
  priceMonthText: string
  priceSuffixText?: ReactNode
}

const isNormalCls = cls`
  bg-[#252533]
`

const isProCls = cls`
  bg-[linear-gradient(159.53deg,#040404_4.52%,#1A1A24_50.57%,#040404_96.61%)]
`

const PlanCardTemplate: React.FC<IPlanCardTemplateProps> = (props) => {
  const {
    className,
    productTextInfo,
    productType,
    productName,
    BuyButton,
    priceMonthText,
    priceSuffixText,
  } = props

  const isPro = productType === EProductType.PRO
  const isBasic = productType === EProductType.BASIC

  const { wordsText, featuresTextList } = productTextInfo

  const textList = useMemo(() => {
    if (featuresTextList?.length) {
      return [
        { label: wordsText, enabled: true, showIcon: false },
        ...featuresTextList,
      ].filter((item) => item) as TListItem[]
    }
    return []
  }, [featuresTextList, wordsText])

  const showPrimary = isPro || isBasic
  let productIconName: string = ''
  if (isBasic) productIconName = cls`i-cus--tad-member-first-color`

  /** 放这里，后面看者的样式有什么用
   * ${isSmallSize && 'px-6 py-9'}
   * ${isMiddleSize && 'p-8 py-9'}
   */
  return (
    <li
      className={tw`
        scrollbar
        text-f-text
        relative w-full
        overflow-auto rounded-[16px]
        px-5
        pb-6 pt-4
        text-start
        transition-all
        hover:translate-y-[-8px]
        ${className}
        ${isPro ? isProCls : isNormalCls}

      `}
    >
      <div className={cls`flex flex-col gap-y-4`}>
        {/* 产品名称 */}
        <div
          className={cls`
            flex items-center justify-start gap-x-1
            text-left
            text-base
          `}
        >
          {isPro && (
            <LazyImage
              src='/images/cus-tad-member-second-color.png'
              alt='cus-tad-member-second-color'
              width={20}
              height={20}
            />
          )}

          {isBasic && (
            <span
              className={cls`
                size-5
                ${productIconName}
              `}
            ></span>
          )}

          {productName}
          {isPro && (
            <span className='flex items-center justify-center rounded-[4px] border border-[#663c00] px-[5px] text-xs text-[#ffaa33]'>
              <Trans>Best Offer</Trans>
            </span>
          )}
        </div>
        {/* 价格 */}
        <div className={cls`flex items-end justify-start gap-x-1 text-white`}>
          <span
            className={cls`mb-[5px] text-center text-sm ${showPrimary ? 'text-f-primary' : ''}`}
          >
            $
          </span>
          <span
            className={cls`text-4xl font-semibold leading-10 ${showPrimary ? 'text-f-primary' : ''}`}
          >
            {priceMonthText}
          </span>
          <span className='mb-[5px] text-center text-sm'>
            {priceSuffixText || <Trans>monthly</Trans>}
          </span>
        </div>
        {/* 购买按钮 */}
        {BuyButton}
      </div>
      <ListItem
        className={cls`
          mt-5
        `}
        liClassName={(enabled) => {
          return cls`
            ${enabled ? 'text-[#A0A0AA]' : 'text-[#707080]'}
          `
        }}
        textList={textList}
      />
    </li>
  )
}

export default PlanCardTemplate
